import { BASE_URL } from '@core/api/constants';

/**
 * LTI 1.3 Advantage dynamic registration endpoint of the LTI connector
 * (`IntegrationController.RegisterPlatform` in the backend). The LMS calls it
 * with its `openid_configuration` and `registration_token`; `company_id` binds
 * the registered platform to a WEAVR company.
 */
const LTI_DYNAMIC_REGISTRATION_PATH = 'lti-connector-app/api/v1/integration/lti_1.3/register';

export const buildLtiRegistrationUrl = (companyId: string) =>
    `${BASE_URL}/${LTI_DYNAMIC_REGISTRATION_PATH}?company_id=${encodeURIComponent(companyId)}`;
